<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
        <Modal v-model:visible="show_detail" backdrop>
            <template v-slot:header>
                <h2 class="text-2xl font-bold">Dettaglio</h2>
            </template>
            <template v-slot:main>
                <table>
                    <tr v-for="(v,k) in detail" :key="k">
                        <td class="w-1/2 font-bold border border-next-dark-gray">{{ k }}:</td>
                        <td class="w-1/2 border border-next-dark-gray">{{ v }}</td>
                    </tr>
                </table>
            </template>
            <template v-slot:footer>
                <div class="flex justify-between pt-3">
                    <NextButton variant="outline-secondary"
                                @click="show_detail =false"
                                class="py-2 px-4 w-full">
                        Chiudi
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 pb-8">
        <div class="m-auto pt-5">
            <h2 class="text-3xl font-bold mb-4">Costi preventivo: {{ lista.rows[0]?.NODO || '---' }}</h2>

            <div class="flex flex-col col-span-2 mb-2">
                <Field field_name="Cerca" @update:modelValue="lista.debounceSearch"
                       v-model="lista.search"
                       placeholder="Cerca"></Field>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 border-separate border-spacing-3 py-4 table-fixed"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_1`]="context">
                        <router-link class="text-next-atp" :to="{name:'DettaglioOda',  params:{ id: id, ditta: c.DITTA, n_reg:c.NUMREG }}">{{ c[cols[1].prop] }}
                        </router-link>
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        {{ $filters.toFormat(c.MOLT, 0, 0) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        {{ $filters.toFormat(c.QTA, 0, 0) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                        {{ $filters.toEuroCurrency(c.IMPORTO_VALUTA) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_7`]="context">
                        {{ $filters.toEuroCurrency(c.TOTIMP) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_9`]="context">
                        {{ $filters.toEuroCurrency(c.VALORETRASFORMATO) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_10`]="context">
                        {{ $filters.toEuroCurrency(c.VALORERESIDUO) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_11`]="context">
                        <span @click="showData(c)"
                              class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></span>

                    </template>

                </NextTable>
            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>

        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import sottoProgettiManager, {sottoProgettiVersioneManager} from "@/api/SottoProgetti";
import NextButton from "@/components/NextButton.vue";
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Lista from "@/setup/ListaCerca";
import Paginator from "@/components/Paginator.vue";
import Field from "@/components/Field.vue";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/Loading.vue";


@Options({
    name: 'CostiRicaviPreventivoSottoProgetto',
    components: {Loading, Modal, Field, Paginator, InfiniteLoading, NextTable, NextButton},
    props: {
        id: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class CostiRicaviPreventivoSottoProgetto extends Vue {
    lista: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.costiPreventivo));
    id!: string;
    show_detail = false
    detail = null

    created() {
        this.lista.callBinds = [this.id]
        //@ts-ignore
        this.lista.apiParams = this.$route.query
        this.lista.fetchData()
    }

    showData(data: any) {
        this.detail = data
        this.show_detail = true
    }

    cols = [
        {
            name: 'Fornitore',
            prop: 'RAGIONE_SOCIALE',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'N° ODA',
            prop: 'NUM_ODA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'Tipo Doc',
            prop: 'TIPODOC',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'whitespace-nowrap px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'Descrizione',
            prop: 'DESCARTICOLO',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'X',
            prop: 'MOLT',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'Q.tà',
            prop: 'QTA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'Importo',
            prop: 'IMPORTO_VALUTA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'whitespace-nowrap text-right px-2 bg-next-gray-md-dark',
            resizable: true,
            width: 20,
        },
        {
            name: 'Totale imponibile',
            prop: 'TOTIMP',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true,
            width: 20,
        },
        {
            name: 'Aliquota Iva',
            prop: 'ALIQIVA',
            orderable: true,
            class: ' whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'Valore trasformato imponibile',
            prop: 'VALORETRASFORMATO',
            orderable: true,
            class: ' whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true,
        },
        {
            name: 'Valore residuo imponibile',
            prop: 'VALORERESIDUO',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true,
            width: 20,
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss" scoped>
.table-costi-ricavi {
    td {
        @apply p-2 text-sm relative bg-next-gray-md-dark
    }
}
</style>
